<div class="searchbar-top gap-2 border-bottom">
  <div class="input-group m-0 sm-inputgroup">
    <select class="form-select form-control pl-15" [(ngModel)]="TagId" aria-label="Default select example"
      (change)="onJobTypeChange()">
      <option value="0">All</option>
      <ng-container *ngFor="let JobType of JobTypeList">
        <option [value]="JobType.id">{{JobType.name}}</option>
      </ng-container>
    </select>
  </div>
  <div class="input-group m-0">
    <input type="text" class="form-control" placeholder="Search...." aria-label="Search" aria-describedby="search-addon"
      [(ngModel)]="Title" (keyup)="search($event)" oninput="this.value = this.value.replace(/^\s+/g, '')" />
    <span class="input-group-text border-0" id="search-addon">
      <i class="fas fa-search"></i>
    </span>
    <span type="button" class="input-group-append" (click)="clearSearch()" *ngIf="searchClose">
      <i class="fas fa-times"></i>
    </span>
  </div>
  <button type="button" class="btn btn-primary common-button m-0" (click)="onEdit(0, 'new')" title="Add Job"><i
      class="fas fa-plus pe-2"></i><span>Add
      Job</span></button>
  <button type="button" class="btn btn-primary common-button m-0 icon-btn" (click)="RefreshGrid()"><i
      class="fa-solid fa-rotate-right"></i></button>
</div>
<div class="card-content p-3">
  <div class="row">
    <div class="col-xl-4 col-md-6 col-12" *ngFor="let job of JobList; let myIndex=index" style="cursor: pointer;">
      <div class="job-box-wrap position-relative">
        <div (click)="ViewAppliedJob(job.jobId, job.title)" class="job-box">
          <h5>
            {{ job.title }}
          </h5>
          <h6>{{ job.companyName }}</h6>
          <p><i class="fa-solid fa-location-dot"></i> {{ job.cityName }}, {{job.stateName}}</p>
          <div class="d-flex align-items-center flex-wrap gap-2" *ngIf="job.jobType">
            <div *ngFor="let jobType of job.jobType.split(',')">
              <div class="job-btn-rouneded">{{ jobType }}</div>
            </div>
          </div>
        </div>
        <div>
          <div class="dropdown">
            <a class="" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
              <i class="fa-solid fa-ellipsis-vertical main-icon"></i>
            </a>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              <li><a class="dropdown-item" (click)="onEdit(job.jobId, 'edit')" title="Edit Job"><i
                    class="fa-solid fa-pen"></i><b>Edit</b></a></li>
              <li><a class="dropdown-item" (click)="Deletepopup(job.jobId, job.title)" title="Delete Job"><i
                    class="fa-solid fa-trash"></i><b>Delete</b></a></li>
              <li>
                <a *ngIf="job.active === true" class="dropdown-item text-success" (click)="onStatus(job.jobId,job.title,job.active)" title="Active / Inactive">
                  <b><i class="fa-solid fa-circle-check"></i>{{CommonConstant.ACTIVE}}</b></a>
                  <a *ngIf="job.active === false" class="dropdown-item text-danger" (click)="onStatus(job.jobId,job.title,job.active)" title="Active / Inactive">
                    <b><i class="fa-solid fa-circle-xmark"></i>{{CommonConstant.INACTIVE}}</b></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="showData" [ngClass]="JobList.length > 0 ? 'hidden' : 'visible'">
      <h5 class="text-center no-data-available py-4">{{NoRecordFound.NoJobFound}}</h5>
    </div>

  </div>

  <mat-paginator #paginator [length]="totalRows" [pageIndex]="currentPage" showFirstLastButtons [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions" (page)="pageChanged($event)" aria-label="Select page">
  </mat-paginator>